import TaxRate from "./TaxRate";
import helpers from "../inc/helpers";

export default class TaxEstimate {
	marketValue: number;
	propertyType: string;
	taxDistrict: TaxRate;
	assessedValue: number;
	fullRate: number;
	effectiveRate: number;
	adjustedTax: number;
	rollback: number;
	reduction: number;
	grossTax: number;
	hb920: number;
	homestead: number;
	fullTax: number;
	halfTax: number;
	nonBusinessCredit: number;
	ownerOccupiedCredit: number;

	constructor(marketValue: number, propertyType: string, taxDistrict: TaxRate) {
		this.marketValue = marketValue;
		this.propertyType = propertyType;
		this.taxDistrict = taxDistrict;

		this.assessedValue = helpers.round(this.marketValue * 0.35, 0);

		this.fullRate = parseFloat(this.taxDistrict.gca_tax_rate_rates);

		switch (this.propertyType) {
			case "Commercial":
			case "Industrial":
				this.effectiveRate = parseFloat(this.taxDistrict.gca_tax_rate_com_ind);
				this.adjustedTax = helpers.round(this.assessedValue * (this.effectiveRate / 1000), 0);
				this.rollback = 0;
				this.reduction = 0;
				this.nonBusinessCredit = 0;
				this.ownerOccupiedCredit = 0;
				break;
			default:
				this.effectiveRate = parseFloat(this.taxDistrict.gca_tax_rate_agr_res);
				this.adjustedTax = helpers.round(this.assessedValue * (this.effectiveRate / 1000), 0);
				this.rollback = helpers.round(this.adjustedTax * 0.1, 0);
				this.reduction = helpers.round(this.adjustedTax * 0.025, 0);
				this.nonBusinessCredit = helpers.round(this.assessedValue * (parseFloat(this.taxDistrict.gca_tax_rate_nonbuscredit) / 1000), 0);
				this.ownerOccupiedCredit = helpers.round(this.assessedValue * (parseFloat(this.taxDistrict.gca_tax_rate_ownerocccredit) / 1000), 0);
		}

		this.grossTax = helpers.round(this.assessedValue * (this.fullRate / 1000), 0);
		this.hb920 = helpers.round(this.grossTax - this.adjustedTax, 0);
		this.homestead = 0;
		this.fullTax = helpers.round(this.adjustedTax - this.rollback - this.reduction, 0);
		this.halfTax = helpers.round((this.adjustedTax - this.rollback - this.reduction) / 2, 0);
	}
}
